export enum JobStatus {
  DRAFT = 'DRAFT',
  OPEN = 'OPEN',
  PAUSED = 'PAUSED',
  CLOSED = 'CLOSED',
}

export enum MatchType {
  EXACT = 'EXACT',
  CONTAINS = 'CONTAINS',
  GREATER_THAN = 'GREATER_THAN',
  REGEX = 'REGEX',
  NOT_EXACT = 'NOT_EXACT',
  NOT_CONTAINS = 'NOT_CONTAINS',
  NOT_EMPTY = 'NOT_EMPTY',
  LESS_THAN = 'LESS_THAN'
}

export type CandidateQuestionFilter = {
  question: string;
  matchType: MatchType;
  match: string;
}

export type Job = {
  id: string
  title: string
  description: string
  atsLink: string
  atsID: string
  videoInterviewLink: string
  skillAssessmentIDs: string[]
  status: JobStatus
  questionnaireFilters?: CandidateQuestionFilter[]
  enabledForAutomation: boolean
}
